import { __assign, __awaiter, __extends, __generator } from "tslib";
import { EventService, } from '@metaos/hub-sdk';
import { logError } from '@office-start/telemetry-service';
var AppHostAuthenticationService = /** @class */ (function (_super) {
    __extends(AppHostAuthenticationService, _super);
    function AppHostAuthenticationService(accessTokenResponseFunction, user, authRedirectUrl) {
        var _this = _super.call(this) || this;
        _this.acquireToken = function (resource, claims, silent) { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!resource) {
                            throw new Error('Resource URL not provided');
                        }
                        return [4 /*yield*/, this.accessTokenResponseFunction('MetaOS', false, resource, undefined, undefined, claims, silent, {
                                category: 'MetaOSApp',
                            })];
                    case 1:
                        response = _a.sent();
                        if (response.success && response.token) {
                            return [2 /*return*/, { token: response.token }];
                        }
                        logError({
                            eventName: 'Access_Token_Response',
                            errorType: 'GetOfficeToken_Error',
                            message: 'Unable to get access token. Access token response error',
                            debugInfo: "acquireToken for resource: ".concat(resource, " failed for MOSAppHost. claims: ").concat(claims, ", isSilent: ").concat(silent),
                        });
                        throw new Error('Unable to get access token');
                }
            });
        }); };
        _this.getUser = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, __assign({}, this.user)];
            });
        }); };
        _this.accessTokenResponseFunction = accessTokenResponseFunction;
        _this.user = user;
        _this.authRedirectUrl = authRedirectUrl;
        return _this;
    }
    Object.defineProperty(AppHostAuthenticationService.prototype, "externalAuthRedirectUrl", {
        get: function () {
            return this.authRedirectUrl;
        },
        enumerable: false,
        configurable: true
    });
    return AppHostAuthenticationService;
}(EventService));
export { AppHostAuthenticationService };
//# sourceMappingURL=AppHostAuthenticationService.js.map